const modalTemplate = `
  <div id="comment-modal-background"></div>
  <div id="comment-modal" class="popup">
    <div class="popup_body">
      <div class="form-line">
        <input id="comment-modal_input-name" placeholder="Name" />
      </div>
      <div id="comment-modal_color-wrapper" class="form-line">
        <div class="color-wrapper">
        
          <div data="rgba(188, 221, 242, 0.8)" style="background: rgba(188, 221, 242, 0.8)" class="color-box"></div>
          <div data="#f2d97d" style="background: #f2d97d" class="color-box"></div>
          <div data="#f7cbb4" style="background: #f7cbb4" class="color-box"></div>
          <div data="#cbeef0" style="background: #cbeef0" class="color-box"></div>
          <div data="#eae1d8" style="background: #eae1d8" class="color-box"></div>
          <div data="#6fc0a0" style="background: #6fc0a0" class="color-box"></div>
        </div>
      </div>
    </div>
    <button class="comment-modal_close-button">Cancel</button>
    <button class="comment-modal_confirm-button">Confirm</button>
  </div>
`

export default class CommentModal {
  constructor({ onSave = () => {}, editor, isInlineComment, comment }) {
    let el = document.createElement('div');
    el.setAttribute('id', 'comment-modal-wrapper');
    this.el = el;

    this.onSave = onSave;
    this.isInlineComment= isInlineComment;
    this.comment = comment;

    this.createModal();
    this.openPopup();
  }

  createModal() {
    this.el.innerHTML += modalTemplate;
    
    if (this.isInlineComment) {
      let colorWrapper = this.el.querySelector('#comment-modal_color-wrapper');
      colorWrapper.parentNode.removeChild(colorWrapper);
    }
    
    this.addEvents();
    document.body.appendChild(this.el);

    this.initValues();
  }

  initValues() {
    let { name, color } = this.comment
    
    if (name) {
      document.getElementById('comment-modal_input-name').value = name;
    }

    if (color) {
      let colorBoxes = this.el.querySelectorAll('.color-box')
      for (const colorBox of colorBoxes) {
        if (colorBox.getAttribute('data') === color) {
          colorBox.classList.add('selected');
        }
      }
    }

    document.getElementById('comment-modal_input-name').focus();
  }

  addEvents() {
    this.el.querySelector('#comment-modal-background').addEventListener('click', this.closePopup.bind(this), false);
    this.el.querySelector('.comment-modal_close-button').addEventListener('click', this.closePopup.bind(this), false);
    this.el.querySelector('.comment-modal_confirm-button').addEventListener('click', this.saveClick.bind(this), false);

    let colorBoxes = this.el.querySelectorAll('.color-box')
    for (const colorBox of colorBoxes) {
      colorBox.addEventListener('click', this.toggleSelectedClass.bind(this), false);
    }
  }

  toggleSelectedClass(e) {
    let colorBoxes = this.el.querySelectorAll('.color-box')
    for (const colorBox of colorBoxes) {
      colorBox.classList.remove('selected');
    }
    e.target.classList.add('selected');
  }

  removeEvents() {
    this.el.querySelector('#comment-modal-background').removeEventListener('click', this.closePopup.bind(this), false);
    this.el.querySelector('.comment-modal_close-button').removeEventListener('click', this.closePopup.bind(this), false);
    this.el.querySelector('.comment-modal_confirm-button').removeEventListener('click', this.saveClick.bind(this), false);

    let colorBoxes = this.el.querySelectorAll('.color-box')
    for (const colorBox of colorBoxes) {
      colorBox.removeEventListener('click', this.toggleSelectedClass.bind(this), false);
    }
  }

  openPopup() {
    let el = document.getElementById('comment-modal');
    el.style.display = 'block';

    document.getElementById('comment-modal-wrapper').classList.add('visible');
  }
  
  closePopup() {
    let el = document.getElementById('comment-modal');
    el.style.display = 'none';
    document.getElementById('comment-modal-wrapper').classList.remove('visible');

    this.removeEvents();
    let element = document.getElementById('comment-modal-wrapper');
    document.body.removeChild(element);
  }

  saveClick() {
    let name = this.el.querySelector('#comment-modal_input-name').value;
    let color

    if (!this.isInlineComment) {
      color = document.querySelector('.color-box.selected').getAttribute('data');
    }

    this.onSave({ name, color }).then(() => {
      this.closePopup();
    });
  }
}
